import Vue from 'vue'
import Router from 'vue-router'

import HelloWorld from '@/components/HelloWorld'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      redirect: "/homes",
      component: HelloWorld,
      children: [
        {
          path: '/homes',
          name: 'homes',
          component: resolve => require(['@/components/nav/homeItem'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/aboutus',
          name: 'aboutus',
          component: resolve => require(['@/components/nav/aboutusItem'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/editorial',
          name: 'editorial',
          component: resolve => require(['@/components/nav/Editorialtem'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/opcItem',
          name: 'opcItem',
          component: resolve => require(['@/components/nav/opcItem'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/newsItem',
          name: 'newsItem',
          component: resolve => require(['@/components/nav/newsItem'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/payment',
          name: 'payment',
          component: resolve => require(['@/components/nav/payment'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/chineseItem',
          name: 'chineseItem',
          component: resolve => require(['@/components/nav/chineseItem'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        // {
        //   path: '/englishItem',
        //   name: 'englishItem',
        //   component: resolve => require(['@/components/nav/chineseItem'], resolve),
        //   meta: {
        //     keepAlive: true,
        //     isBack: false
        //   }
        // },
        {
          path: '/specialIssues',
          name: 'specialIssues',
          component: resolve => require(['@/components/nav/specialIssues'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/specialIssuesInfo',
          name: 'specialIssuesInfo',
          component: resolve => require(['@/components/nav/specialIssuesInfo'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/bookItem',
          name: 'bookItem',
          component: resolve => require(['@/components/nav/bookItem'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/bookInfo',
          name: 'bookInfo',
          component: resolve => require(['@/components/nav/bookInfo'], resolve)
        },
        {
          path: '/conferenceItem',
          name: 'conferenceItem',
          component: resolve => require(['@/components/nav/conferenceItem'], resolve)
        },
        {
          path: '/contactItem',
          name: 'contactItem',
          component: resolve => require(['@/components/nav/contactItem'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/conferenceInfo',
          name: 'conferenceInfo',
          component: resolve => require(['@/components/nav/conferenceInfo'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/searchItem',
          name: 'searchItem',
          component: resolve => require(['@/components/nav/searchItem'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/buyItem',
          name: 'buyItem',
          component: resolve => require(['@/components/nav/buyItem'], resolve),
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/newsInfo',
          name: 'newsInfo',
          component: resolve => require(['@/components/nav/newsInfo'], resolve)
        },
      ]
    },
    // // vue异步组件
    {
      path: '/404',
      name: '404',
      component: resolve => require(['@/components/nav/NoView'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js